/**
 * Auto-hide notice sukses WooCommerce (.woocommerce-message).
 *
 * Notice ini muncul di banyak tempat (habis add to cart, update keranjang,
 * hapus item, pasang kupon) dan tidak pernah hilang sendiri — di halaman
 * checkout, empat kali add to cart berarti empat kotak notice yang menumpuk di
 * atas isi keranjang. Modul ini menutupnya sendiri setelah 5 detik.
 *
 * Kalau notice-nya lebih dari satu, penutupannya dijeda berurutan
 * (STAGGER_DELAY antar notice) supaya tidak lenyap serentak — yang menghilang
 * satu per satu terasa lebih halus, terutama karena notice di bawahnya ikut
 * bergeser naik saat yang di atas mengempis.
 *
 * Notice yang datang belakangan (dirender ulang lewat AJAX WooCommerce) ikut
 * terjaring MutationObserver, jadi tidak perlu dipanggil ulang manual dari
 * modul lain.
 *
 * CSS transisinya ada di src/scss/component/_woocommerce.scss.
 */

var NOTICE_SELECTOR = ".woocommerce-message";
var HIDING_CLASS = "dufeng-notice-hiding";
var FLAG_ATTR = "data-dufeng-autohide";

var HIDE_DELAY = 5000;
// Jeda antar notice saat ada beberapa yang antre ditutup.
var STAGGER_DELAY = 400;
// Cadangan kalau transitionend tidak pernah datang (mis. elemen keburu
// tersembunyi karena parent-nya ikut dirender ulang).
var TRANSITION_TIMEOUT = 600;

// Berapa notice yang sedang mengantre; jadi pengali jeda berurutannya.
var pending = 0;

function prefersReducedMotion() {
  return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function remove(notice) {
  notice.style.display = "none";
}

function hide(notice) {
  if (!notice.isConnected) return;

  if (prefersReducedMotion()) {
    remove(notice);
    return;
  }

  // Tinggi aslinya dikunci dulu supaya animasi mengempisnya punya titik awal
  // yang jelas (dari `auto` tidak ada yang bisa ditransisikan).
  notice.style.maxHeight = notice.scrollHeight + "px";
  notice.style.overflow = "hidden";

  // Paksa reflow supaya max-height di atas benar-benar terpakai sebagai nilai
  // awal, bukan ikut tergabung dengan perubahan di baris berikutnya.
  void notice.offsetHeight;

  notice.classList.add(HIDING_CLASS);

  var done = false;
  var finish = function () {
    if (done) return;
    done = true;
    remove(notice);
  };

  notice.addEventListener("transitionend", finish);
  setTimeout(finish, TRANSITION_TIMEOUT);
}

function schedule(notice) {
  if (notice.getAttribute(FLAG_ATTR)) return;
  notice.setAttribute(FLAG_ATTR, "1");

  var delay = HIDE_DELAY + pending * STAGGER_DELAY;
  pending++;

  setTimeout(function () {
    pending = Math.max(0, pending - 1);
    hide(notice);
  }, delay);
}

function scheduleWithin(root) {
  if (!root || 1 !== root.nodeType) return;

  if (root.matches && root.matches(NOTICE_SELECTOR)) schedule(root);

  var found = root.querySelectorAll ? root.querySelectorAll(NOTICE_SELECTOR) : [];
  for (var i = 0; i < found.length; i++) {
    schedule(found[i]);
  }
}

export function initNotices() {
  scheduleWithin(document.body);

  if (!window.MutationObserver) return;

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        scheduleWithin(added[j]);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
